<template>
  <div class="header">
    <div class="header-left">
      <img class="logo" src="../../assets/home/logo.png" alt="" />
    </div>
    <div class="header-right">
      <div class="connect-button" @click.stop="onConnect">
        <span :class="{ 'network-error': common.networkError }">
          {{ connectText }}
        </span>
        <div class="wallet-panel-bg" v-if="walletPanelVisible"></div>
        <WalletPanel
          v-if="walletPanelVisible"
          @close="walletPanelVisible = false"
        />
      </div>
      <div class="language-wrap" @click="changeLang">
        <img src="../../assets/home/language.png" alt="" />
        <span>{{ t('language') }}</span>
      </div>
      <img
        class="language-mobile-icon"
        src="../../assets/home/language.png"
        alt=""
        @click="openLanguageModal"
      />
    </div>
  </div>
</template>

<script setup>
import emitter from '@/utils/bus';
import _ from 'lodash';
import { storeToRefs } from 'pinia';
import { ref, computed, watch, onMounted, defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
const { locale, t } = useI18n();

import { useCommonStore } from '../../stores/common';
const common = useCommonStore();

import { useWalletStore } from '../../stores/wallet';
const walletStore = useWalletStore();
const { walletInfo } = storeToRefs(walletStore);

import WalletPanel from '../wallet/WalletPanel.vue';

const emit = defineEmits(['connect', 'openLanguageModal']);
const props = defineProps({
  network: {
    type: String,
  },
});

const walletPanelVisible = ref(false);

onMounted(() => {
  document.body.addEventListener('click', () => {
    walletPanelVisible.value = false;
  });

  emitter.on('close-wallet-panel', () => {
    walletPanelVisible.value = false;
  });
});

const darkModeImg = computed(() => {
  return common.isDark ? '-dark' : '';
});

const connectText = computed(() => {
  if (common.isTP) {
    if (walletInfo.value[props.network]) {
      return (
        walletInfo.value[props.network]?.account.slice(0, 5) +
        '...' +
        walletInfo.value[props.network]?.account.slice(-5)
      );
    } else {
      return t('home.networkError')
    }
  } else {
    if (common.networkError) {
      return t('home.networkError')
    } else {
      if (walletInfo.value && Object.keys(walletInfo.value).length) {
        return `${t('wallet.connected')}(${
          Object.keys(walletInfo.value).length
        })`;
      } else {
        return t('home.connect');
      }
    }
  }
});

const isZh = computed(() => {
  return locale.value === 'zh';
});

const openLanguageModal = () => {
  emit('openLanguageModal');
};

const changeLang = () => {
  if (locale.value === 'zh') {
    locale.value = 'en';
  } else {
    locale.value = 'zh';
  }
};

const onConnect = () => {
  if (common.isTP) {
    emit('connect');
  } else {
    emit('close');
    walletPanelVisible.value = !walletPanelVisible.value;
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  height: 60px;
  .header-left {
    display: flex;
    .logo {
      height: 28px;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    .connect-button {
      position: relative;
      display: flex;
      span {
        height: 35px;
        background: #ffffff;
        border-radius: 48px;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 500;
        color: #2980fe;
        text-align: center;
        line-height: 35px;
        cursor: pointer;
        &.network-error {
          color: #f56459;
          background: #ffecec;
        }
      }
      .wallet-panel-bg {
        display: none;
      }
    }
    .language-wrap {
      margin-left: 24px;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 22px;
        height: 22px;
      }
      span {
        margin-left: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #1a202c;
      }
    }
    .language-mobile-icon {
      display: none;
    }
  }
}
@media screen and (max-width: 767px) {
  .header {
    background: #fff;
    padding: 0 16px;
    height: 54px;
    .header-left {
      .logo {
        height: 22px;
      }
    }
    .header-right {
      .connect-button {
        span {
          font-size: 12px;
          height: 32px;
          line-height: 32px;
          background: #ebf4ff;
        }
        .wallet-panel-bg {
          position: fixed;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background: rgba(0, 0, 0, 0.7);
          display: block;
          z-index: 9;
        }
      }
      .language-wrap {
        display: none;
      }
      .language-mobile-icon {
        display: block;
        margin-left: 10px;
        width: 22px;
        height: 22px;
      }
    }
  }
}
</style>
